



















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { calMax, calMin } from '@/utils/common'
import * as echarts from 'echarts'
@Component({
  name: 'UserStatistics'
})
export default class extends Vue {
  @Prop() private userdata!: any
  @Watch('userdata')
  getData() {
    this.$nextTick(() => {
      this.initChart()
    })
  }
  initChart() {
    type EChartsOption = echarts.EChartsOption
    const chartDom = document.getElementById('usermain') as any
    const myChart = echarts.init(chartDom)
    var option: any
    // 调用方法，获取数据的最大值&最小值
    var maxData1 = calMax(this.userdata.amount)
    var maxData2 = calMax(this.userdata.newNum)
    var minData1 = calMin(this.userdata.amount)
    var minData2 = calMin(this.userdata.newNum)
    option = {
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#fff', //背景颜色（此时为默认色）
        borderRadius: 2, //边框圆角
        textStyle: {
          color: '#333', //字体颜色
          fontSize: 12, //字体大小
          fontWeight: 300
        }
      },
      grid: {
        top: '5%',
        left: '0',
        right: '0',
        bottom: '12%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLabel: {
          //X轴字体颜色
          textStyle: {
            color: '#666',
            fontSize: '12px'
          }
        },
        axisLine: {
          //X轴线颜色
          lineStyle: {
            color: '#E5E4E4',
            width: 1 //x轴线的宽度
          }
        },
        data: this.userdata.date //后端传来的动态数据
      },
      yAxis: [
        //左侧值
        {
          type: 'value',
          min: minData1,
          max: maxData1,
          splitNumber: 5, //设置坐标轴的分割段数
          interval: (maxData1 - minData1) / 5, // 标轴分割间隔
          axisLabel: {
            textStyle: {
              color: '#666',
              fontSize: '12px'
            },
            formatter: function(v) {
              return v.toFixed(0) //0表示小数为0位，1表示1位小数，2表示2位小数
            }
          }
        },
        //右侧值
        {
          type: 'value',
          min: minData2,
          max: maxData2,
          splitNumber: 5,
          interval: (maxData2 - minData2) / 5,
          axisLabel: {
            textStyle: {
              color: '#666',
              fontSize: '12px'
            },
            formatter: function(v) {
              return v.toFixed(0) //0表示小数为0位，1表示1位小数，2表示2位小数
            }
          }
        }
      ],
      series: [
        {
          name: '用户总量',
          type: 'line',
          smooth: true, //否平滑曲线
          showSymbol: false, //未显示鼠标上移的圆点
          symbolSize: 10,
          itemStyle: {
            normal: {
              color: '#FFD000',
              lineStyle: {
                color: '#FFD000'
              }
            },
            emphasis: {
              color: '#fff',
              borderWidth: 5,
              borderColor: '#FFC100'
            }
          },

          data: this.userdata.amount
        },
        {
          name: '新增用户',
          type: 'line',
          smooth: true, //否平滑曲线
          showSymbol: false, //未显示鼠标上移的圆点
          symbolSize: 10, //圆点大小
          itemStyle: {
            normal: {
              color: '#FD7F7F',
              fontWeigth: 300,
              lineStyle: {
                color: '#FD7F7F'
              }
            },
            emphasis: {
              // 圆点颜色
              color: '#fff',
              borderWidth: 5,
              borderColor: '#FD7F7F'
            }
          },
          yAxisIndex: 1, //在单个图表实例中存在多个y轴的时候有用
          data: this.userdata.newNum
        }
      ]
    }
    option && myChart.setOption(option)
    window.addEventListener('resize', function() {
      myChart.resize()
    })
  }
}
